import React, { useState } from "react";
import PageWrapper from "./PageWrapper";
import { useDatabase } from "../data/DatabaseContext";
import IFullUserType from "../data/types/fullUserType";
import { useParams } from "react-router";
import PreviewApp from "../preview/Preview.App";
import IStoryTreeType from "../data/types/storyTreeType";

const StoryTreePreviewPage = () => {
  const { userId, storyTreeId }: { userId: string; storyTreeId: string } = useParams();
  const { state, getFullUser, getStoryTree } = useDatabase();
  const { user }: IFullUserType = getFullUser(userId);
  const storyTree: IStoryTreeType = getStoryTree(storyTreeId);

  const heading: string = "User: " + user.name + " > Story Tree: " + storyTree.name + " - preview";

  const tree = getStoryTree(storyTreeId);

  return (
    <PageWrapper heading={heading}>
      <div style={{ padding: 40, height: "calc(100% - 80px)", display: "flex", justifyContent: "center" }}>
        <PreviewApp rootScreenId={tree.rootScreenId}></PreviewApp>
      </div>
    </PageWrapper>
  );
};

export default StoryTreePreviewPage;
